import type { SurveyLanguage } from '@shared/types/surveyLanguage';

function apiBase(): string {
  const raw = import.meta.env.VITE_API_BASE_URL;
  if (typeof raw === 'string' && raw.length > 0) return raw.replace(/\/$/, '');
  return '';
}

export type RequestOtpResult =
  | { ok: true; customerUuid: string }
  | { ok: false; error: string; status: number };

/**
 * Creates / updates Customer, sends 6-digit OTP via sms123.net. Locks unique code row in DB.
 */
export async function requestOtp(params: {
  uniqueCode: string;
  mobileLocalDigits: string;
  ageBand: string;
  language: SurveyLanguage;
}): Promise<RequestOtpResult> {
  const res = await fetch(`${apiBase()}/api/v1/otp/request`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      uniqueCode: params.uniqueCode,
      mobileLocalDigits: params.mobileLocalDigits,
      ageBand: params.ageBand,
      language: params.language,
    }),
  });

  const data = (await res.json()) as { ok?: boolean; customerUuid?: string; error?: string };

  if (res.ok && data.ok && typeof data.customerUuid === 'string') {
    return { ok: true, customerUuid: data.customerUuid };
  }

  return {
    ok: false,
    error: typeof data.error === 'string' ? data.error : 'Unable to send OTP. Please try again.',
    status: res.status,
  };
}

export type VerifyOtpResult = { ok: true } | { ok: false; error: string };

export async function verifyOtp(params: {
  customerUuid: string;
  otp: string;
}): Promise<VerifyOtpResult> {
  const res = await fetch(`${apiBase()}/api/v1/otp/verify`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      customerUuid: params.customerUuid,
      otp: params.otp,
    }),
  });

  const data = (await res.json()) as { ok?: boolean; error?: string };

  if (res.ok && data.ok) {
    return { ok: true };
  }

  return {
    ok: false,
    error: typeof data.error === 'string' ? data.error : 'Invalid OTP.',
  };
}
